export default __webpack_public_path__ + "static/media/light1.2076a40b.png";